<template>
  <div class="container">
    <div class="month-wrapper">
      <div class="handle-wrapper">
        <DatePicker
          type="year"
          placement="bottom-end"
          placeholder="选择年份"
          style="width: 200px; margin-right: 30px"
          v-model="chooseYear"
          @on-change="changeYearDate"
        />
        <Input
          v-model="searchTextByMonth"
          search
          placeholder="搜索客户..."
          @on-change="searchCustomerByMonth"
          clearable
          icon="ios-search"
          style="width: 230px; margin-right: 20px"
        ></Input>
        <Select
          placeholder="筛选业务员"
          v-model="salesVisibleByMonth"
          label-in-value
          multiple
          filterable
          @on-change="choseSalesVisibleByMonth"
          style="width: 180px; margin-right: 30px"
        >
          <Option
            v-for="item in salesVisibleMember"
            :value="item._id"
            :key="item._id"
          >{{ item.name }}</Option>
        </Select>
      </div>
      <div class="month-table table-wrapper" ref="tableWrapper">
        <Table
        :columns="yearColumns"
        :data="monthList"
        :height="tableHeight"
        @on-sort-change="sortMonthVolPlanMethod"
        border
        :loading="monthTableLoading"
        >
          <template slot-scope="{ row, column, index }" slot="arTable">
              <div class="arTable-cell">
                {{ dataHandle(row, column, index) }}
              </div>
          </template>
        </Table>
      </div>
    </div>
    <div class="day-wrapper">
      <div class="handle-wrapper">
        <DatePicker
          type="month"
          placement="bottom-end"
          placeholder="选择月份"
          style="width: 200px; margin-right: 30px"
          v-model="chooseMonth"
          @on-change="changeMonthDate"
        />
        <Input
          v-model="searchTextByDay"
          search
          placeholder="搜索客户..."
          @on-change="searchCustomerByDay"
          clearable
          icon="ios-search"
          style="width: 230px; margin-right: 20px"
        ></Input>
        <Select
          placeholder="筛选业务员"
          v-model="salesVisibleByDay"
          label-in-value
          multiple
          filterable
          @on-change="choseSalesVisibleByDay"
          style="width: 180px; margin-right: 30px"
        >
          <Option
            v-for="item in salesVisibleMember"
            :value="item._id"
            :key="item._id"
          >{{ item.name }}</Option>
        </Select>
      </div>
      <div class="day-table table-wrapper" ref="tableWrapper">
        <Table
        :columns="monthColumns"
        :height="tableHeight"
        border
        @on-sort-change="sortDayVolPlanMethod"
        :loading="dayTableLoading"
        :data="dayList"
        >
          <template slot-scope="{ row, column, index }" slot="arTable">
            <div class="arTable-cell">
              {{ dataHandle(row, column, index) }}
            </div>
          </template>
        </Table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import dayjs from "dayjs";
import _ from "lodash";

export default {
  name: "SalesOrderVol",
  data() {
    return {
      tableHeight: 300,
      chooseYear: null,
      chooseMonth: null,
      dayFilterQuery: {},
      monthFilterQuery: {},
      dayTableLoading: false,
      monthTableLoading: false,
      dayList: [],
      monthList: [],
      searchTextByMonth: null,
      searchTextByDay: null,
      salesVisibleByMonth: "",
      salesVisibleByDay: "",
      salesVisibleMember: [],
      yearColumns: [
        {
          title: "客户",
          key: "customer",
          fixed: "left",
          minWidth: 200,
          maxWidth: 250,
          render: (h, params) => {
            return h(
              "span",
              {
                style: { color: "#42b983" },
              },
              params.row.customer.name
            );
          },
        },
        {
          title: "合计",
          key: "volPlanSum",
          align: "right",
          fixed: "left",
          sortable: true,
          minWidth: 70,
          maxWidth: 70,
          render: (h, params) => {
            return h(
              "span",
              params.row.volPlanSum.toFixed()
            );
          },
        },
      ],
      monthColumns: [
        {
          title: "客户",
          key: "customer",
          fixed: "left",
          minWidth: 250,
          render: (h, params) => {
            return h(
              "span",
              {
                style: { color: "#42b983" },
              },
              params.row.customer.name
            );
          },
        },
        {
          title: "合计",
          key: "volPlanSum",
          align: "right",
          fixed: "left",
          sortable: true,
          maxWidth: 70,
          minWidth: 70,
          render: (h, params) => {
            return h(
              "span",
              params.row.volPlanSum.toFixed()
            );
          },
        },
      ],
    }
  },
  methods: {
    ...mapActions({
      salesOrderVolByDay: "salesOrder/salesOrderVolByDayAction",
      salesOrderVolByMonth: "salesOrder/salesOrderVolByMonthAction",
      getUsersList: "user/getSimpleUserListAction",
    }),
    async loadSalesOrderVolByDay() {
      this.monthColumns.splice(2, this.monthColumns.length);
      if (this.searchTextByDay) {
        this.dayFilterQuery.cus_name = this.searchTextByDay;
      } else {
        delete this.dayFilterQuery.cus_name;
      }
      try {
        this.dayTableLoading = true;
        this.dayList  = await this.salesOrderVolByDay(this.dayFilterQuery)
        const dayNum = dayjs(this.dayFilterQuery.yearMonth).daysInMonth()
        for (let i = 0; i < dayNum; i++) {
          this.monthColumns.push({
            title: `${i + 1}`,
            key: `${i + 1}`,
            sortable: true,
            slot: `arTable`,
            align: "right",
            minWidth: 60,
            maxWidth: 60,
          })
        }
        this.dayTableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败：${error}`);
        this.dayTableLoading = false;
      }
    },
    async loadSalesOrderVolByMonth() {
      this.yearColumns.splice(2, this.yearColumns.length);
      if (this.searchTextByMonth) {
        this.monthFilterQuery.cus_name = this.searchTextByMonth;
      } else {
        delete this.monthFilterQuery.cus_name;
      }
      try {
        this.monthTableLoading = true;
        this.monthList  = await this.salesOrderVolByMonth(this.monthFilterQuery)
        for (let i = 0; i < 12; i++) {
          this.yearColumns.push({
            title: `${i + 1}`,
            key: `${i + 1}`,
            slot: `arTable`,
            sortable: true,
            sortable: 'custom',
            align: "right",
            minWidth: 60,
            maxWidth: 60,
          })
        }
        this.monthTableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败：${error}`);
        this.monthTableLoading = false;
      }
    },
    async changeYearDate(e) {
      if (e) {
        this.monthFilterQuery.year = e;
      } else {
        this.monthFilterQuery.year = dayjs().format("YYYY");
      }
      await this.loadSalesOrderVolByMonth();
    },
    async changeMonthDate(e) {
      if (e) {
        this.dayFilterQuery.yearMonth = e;
      } else {
        this.dayFilterQuery.yearMonth = dayjs().format("YYYY-M");
      }
      await this.loadSalesOrderVolByDay();
    },
    searchCustomerByDay: _.debounce(function() {
      this.loadSalesOrderVolByDay()
    }, 1000),
    searchCustomerByMonth: _.debounce(function() {
      this.loadSalesOrderVolByMonth()
    }, 1000),
    async getSalesVisibleMethod() {
      const data = await this.getUsersList({
        simpleRole: "salesLead,sales,salesAssist",
        limit: 99,
      });
      this.salesVisibleMember = data.userList;
    },
    async choseSalesVisibleByMonth(salesVisibleMember) {
      if (salesVisibleMember) {
        this.monthFilterQuery.salesVisibleMember = salesVisibleMember
          .map((x) => x.value)
          .join(",");
      } else {
        delete this.monthFilterQuery.salesVisibleMember;
      }
      await this.loadSalesOrderVolByMonth();
    },
    async choseSalesVisibleByDay(salesVisibleMember) {
      if (salesVisibleMember) {
        this.dayFilterQuery.salesVisibleMember = salesVisibleMember
          .map((x) => x.value)
          .join(",");
      } else {
        delete this.dayFilterQuery.salesVisibleMember;
      }
      await this.loadSalesOrderVolByDay();
    },
    sortMonthVolPlanMethod(item) {
      let tempArr = JSON.parse(JSON.stringify(this.monthList))
      this.monthList = []
      if (item.order === 'asc') {
        this.monthList = tempArr.sort(this.sortMethod(item.key, 'asc'))
      } else if (item.order === 'desc') {
        this.monthList = tempArr.sort(this.sortMethod(item.key, 'asc')).reverse()
      } else {
        this.monthList = tempArr
      }
    },
    sortDayVolPlanMethod(item) {
      let tempArr = JSON.parse(JSON.stringify(this.dayList))
      this.dayList = []
      if (item.order === 'asc') {
        this.dayList = tempArr.sort(this.sortMethod(item.key, 'asc'))
      } else if (item.order === 'desc') {
        this.dayList = tempArr.sort(this.sortMethod(item.key, 'asc')).reverse()
      } else {
        this.dayList = tempArr
      }
    },
    sortMethod(key, type) {
      return function(o1, o2) {
        let value1 = Number(o1.date[key]) ? Number(o1.date[key]) : 0
        let value2 = Number(o2.date[key]) ? Number(o2.date[key]) : 0
        if (value1 < value2) {
          return -1
        }else if(value1 > value2 || value1 === value2) {
          return 1
        } else{
          1
        }
      }
    },
    dataHandle(row, column, index) {
      for (const key in row.date) {
        if (key == column.key) return row.date[key].toFixed()
      }
    },
  },
  async created() {
    this.chooseMonth = dayjs().format("YYYY-M");
    this.chooseYear = dayjs().format("YYYY");
    this.monthFilterQuery.year = this.chooseYear
    this.getSalesVisibleMethod();
  },
  async mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
    await this.loadSalesOrderVolByDay();
    await this.loadSalesOrderVolByMonth();
  },
  destroyed() {
    window.onresize = null;
  },
}
</script>

<style lang="stylus" scoped>
.container
  overflow: scroll;
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center

.table-wrapper
  width 100%
  height calc(100% - 48px)

</style>